<template>
  <div class="page-wrapper" >
    <Tabs  v-model="current" >
        <TabPane name="1" label="综合看板"   v-if="p('report/indexCards')">
          <c1></c1>
        </TabPane>

      <TabPane name="2" label="入住率"  v-if="p('report/checkinRateList')">
        <c2></c2>
      </TabPane>
      <!-- <TabPane name="3" label="接听率" v-if="p('report/answerRate')">
        <c3></c3>
      </TabPane> -->
      <TabPane name="4" label="及时跟进率" v-if="p('report/followInTimeRate')">
        <c4></c4>
      </TabPane>
      <TabPane name="5" label="回款数据" v-if="p('report/flow')">
        <c5></c5>
      </TabPane>
<!--      <TabPane name="6" label="经营看板" v-if="p('management/cards')">-->
<!--        <c6></c6>-->
<!--      </TabPane>-->
<!--      <TabPane name="7" label="成本明细" v-if="p('incomeCostItem/cost/list')">-->
<!--        <c7></c7>-->
<!--      </TabPane>-->
<!--      <TabPane name="8" label="收入明细" v-if="p('incomeCostItem/income/list')">-->
<!--        <c8></c8>-->
<!--      </TabPane>-->
      <!-- <TabPane name="9" label="热力图" v-if="p(['report/getPersonLonAndLat','report/getProjectLonAndLat'])">
        <c9></c9>
      </TabPane> -->

      <TabPane name="10" label="房型档案" v-if="p('report/housetype/location')">
        <c10></c10>
      </TabPane>
<!--      <TabPane name="11" label="水电抄表记录" v-if="p('waterwatt/ordinary/haveRead')">-->
<!--        <c11></c11>-->
<!--      </TabPane>-->
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/reporter/operationReport/index'
  import C2 from '@/views/reporter/checkInRate/index'
  // import C3 from '@/views/reporter/answerRate/index'
  import C4 from '@/views/reporter/followinTime/index'
  import C5 from '@/views/reporter/financial/index'
  // import C6 from '@/views/incomManager/dashBoard/index'
  //
  // import C7 from '@/views/incomManager/cost/index'
  // import C8 from '@/views/incomManager/income/index'
  // import C9 from '@/views/reporter/thermogram/index'
  import  C10 from "@/views/reporter/housetypearchives/index"
  // import C11 from '@/views/smartPower/waterAndElectricityRecord/index'
  import {mixin} from "../../mixin";

  export default {
    name:'operateboard',
    mixins:[mixin],
    components:{
      C1,
      C2,
      // C3,
      C4,
      C5,
      // C9,
      C10,
    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
